import {OS} from '@github-ui/get-os'
import {useDetectedOS} from '@github-ui/swp-core/lib/hooks/use-detected-os'
import {useWindowSize} from '@primer/react-brand/esm'
import type {TuiCapPlayerProps} from './TuiCapPlayer'
import CliDemoDesktop from './DemoDesktop'
import CliDemoMobile from './DemoMobile'

type Props = Omit<TuiCapPlayerProps, 'data' | 'load' | 'cols' | 'rows'>

const CHROME_BY_OS: Partial<Record<OS, TuiCapPlayerProps['chrome']>> = {
  [OS.Windows]: 'windows-inactive',
  [OS.macOS]: 'mac-inactive',
}

// `isLarge` is undefined until the window is measured, and the OS is unknown on the
// server, so the first render uses the mobile recording without a frame. This is
// fine while the demo isn't visible during hydration (e.g. a non-selected tab);
// otherwise the swap would be a visible layout shift.
export default function CliDemo(props: Props) {
  const {isLarge} = useWindowSize()
  const os = useDetectedOS()
  const chrome = CHROME_BY_OS[os] ?? false
  const Demo = isLarge ? CliDemoDesktop : CliDemoMobile

  // The player reads its options once on mount, so remount when the frame changes.
  return <Demo key={String(chrome)} chrome={chrome} {...props} />
}
